import {
  SET_FILE,
  SET_FILE_SUCCEEDED,
  SET_FILE_FAILED,
} from "../../common/constants";

export const initialState = [];

export const fileUploadReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FILE:
      // console.log(action.file);
      return { ...state, file: action.file, status: 1 };
    case SET_FILE_SUCCEEDED:
      return { ...state, file: action.file, status: 0 };
    case SET_FILE_FAILED:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Containers/BulkValidation/reducer.js